var hasSearchParam = function(param) {
    return "object" !== "undefined" ? Boolean(new URLSearchParams(window.location.search).get(param)) : false;
};
var baseConfig = {
    environment: "live",
    affiliateName: "bm",
    SPA: false,
    nextjs: true,
    twa: hasSearchParam("twa"),
    hasTduid: hasSearchParam("tduid"),
    blockUserCentrics: true,
    anonymizeIP: true,
    locale: "",
    language: "",
    market: ""
};
export { baseConfig };
